const safetyImage = 'https://readdy.ai/api/search-image?query=Clean%20modern%20workspace%20with%20laptop%20displaying%20product%20listings%20on%20screen%2C%20warm%20cream%20desk%20surface%2C%20soft%20natural%20daylight%20from%20window%2C%20organized%20peaceful%20atmosphere%2C%20minimal%20editorial%20style%2C%20warm%20neutral%20tones%2C%20subtle%20plant%20decoration%2C%20high%20detail%20lifestyle%20photography&width=800&height=600&seq=safety-fashion-2026&orientation=landscape';

const ctaImage = 'https://readdy.ai/api/search-image?query=Artistic%20fashion%20editorial%20with%20curated%20clothing%20pieces%20and%20accessories%20on%20warm%20sand%20paper%20background%20with%20subtle%20texture%2C%20warm%20neutral%20tones%2C%20minimal%20organic%20composition%2C%20soft%20shadows%2C%20magazine%20spread%20aesthetic%2C%20creative%20layout%2C%20high%20detail%20artistic%20photography&width=1400&height=700&seq=cta-final-2026&orientation=landscape';

export function SafetySection() {
  return (
    <section className="bg-background-50 py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Image */}
          <div className="order-2 lg:order-1">
            <div className="rounded-2xl overflow-hidden">
              <img
                src={safetyImage}
                alt="Itaobuy Spreadsheet sicurezza online"
                className="w-full h-auto object-cover"
              />
            </div>
          </div>

          {/* Text */}
          <div className="order-1 lg:order-2">
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-6">
              Itaobuy Spreadsheet è sicuro?
            </h2>
            <p className="text-foreground-600 text-base leading-relaxed mb-8">
              La sicurezza online è fondamentale. Prima di utilizzare qualsiasi risorsa è importante verificare fonti, informazioni e affidabilità. Itaobuy Spreadsheet ti aiuta a navigare in modo consapevole, ma è essenziale seguire alcune buone pratiche per proteggere i tuoi dati e i tuoi acquisti.
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              {[
                'Controllare sempre le fonti',
                'Evitare siti falsi',
                'Verificare recensioni',
                'Proteggere dati personali',
              ].map((item) => (
                <div key={item} className="flex items-center gap-2 text-sm text-foreground-600">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                    <i className="ri-shield-check-line text-primary-500"></i>
                  </div>
                  {item}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export function FinalCtaSection() {
  return (
    <section className="bg-background-50 py-16 md:py-24">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="relative rounded-3xl overflow-hidden">
          <img
            src={ctaImage}
            alt="Visita Kaspreadsheet"
            className="w-full h-[300px] md:h-[400px] object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/60 via-foreground-950/20 to-transparent"></div>
        </div>
        <div className="text-center -mt-16 relative z-10">
          <div className="inline-block bg-background-50 rounded-2xl px-8 md:px-14 py-8 md:py-10 shadow-sm">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">
              Inizia ora con <span className="text-primary-500">Itaobuy</span> Spreadsheet
            </h2>
            <p className="text-foreground-500 text-sm mb-6 max-w-md mx-auto">
              Accedi al database completo di prodotti e scopri le migliori offerte disponibili.
            </p>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-8 py-4 bg-primary-500 text-background-50 rounded-full text-base font-semibold hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Visita il Database Completo
              <i className="ri-arrow-right-up-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}